import {z} from 'zod';

import {DiscountTypeSchema} from '@dms/api/warehouse';

export const BulkEditSupplierDiscountGroupsFormSchema = z.object({
  isDiscountTypeEnabled: z.boolean(),
  discountType: DiscountTypeSchema.nullish(),
  isDiscountValueEnabled: z.boolean(),
  discountValue: z.number().min(0).max(100).nullish(),
});

export type BulkEditSupplierDiscountGroupsForm = z.infer<
  typeof BulkEditSupplierDiscountGroupsFormSchema
>;
